var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 419.46502685546875 206.22320556640625",
    filter: "drop-shadow(1.2px 1px 0.5px black)",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "419.46502685546875px",
    height: "206.22320556640625px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 419.46502685546875,
    height: 206.22320556640625,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6727416515350342, 0, 0, 1.6727416515350342, -814.2142200469971, -137.3845443725586)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 504.1000061035156 127.30000305175781 L 518.2000122070312 133.1999969482422 L 518.2000122070312 198.6999969482422 L 496.70001220703125 173.8000030517578 Z",
    className: "st13",
    style: {
      fill: "rgb(245, 138, 31)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.8231,
    y1: 130.7544,
    x2: 551.1698,
    y2: 96.7494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M513.9,107.2c-0.5-3.9-0.1-6.3,2.8-8c3.1-1.9,7.4-0.7,9.6,2.7c3.9,6.1,0,16,0.3,25.2 c-8.5-4.4-19.2-5.3-23.1-11.4c-2.2-3.4-1.4-7.7,1.8-9.6C508.2,104.3,510.6,105,513.9,107.2z",
    style: {
      fill: "url('#SVGID_10_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.2085,
    y1: 123.5516,
    x2: 534.0875,
    y2: 104.7973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M514.3,107.8c-0.4-3.6,0-5.9,2.7-7.5c3-1.8,7-0.8,9,2.3c3.6,5.6-0.2,14.9,0,23.4c-8-4-18-4.7-21.6-10.3 c-2-3.1-1.2-7.1,1.8-8.9C508.9,105.2,511.2,105.8,514.3,107.8z",
    style: {
      fill: "url('#SVGID_11_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M514.3,107.8c-0.4-3.6,0-5.9,2.7-7.5c3-1.8,7-0.8,9,2.4c0,0.1,0.1,0.1,0.1,0.2c-1.8-2.7-5.6-3.4-8.6-1.7 c-2.7,1.6-3.2,3.7-3,7.1c-3-1.7-5.1-2.2-7.9-0.5c-2.9,1.8-3.9,5.4-2.2,8.2c0-0.1-0.1-0.1-0.1-0.2c-2-3.1-1.2-7.1,1.8-8.9 C508.9,105.2,511.2,105.8,514.3,107.8z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M514.6,108.3c-0.3-3.4,0.3-5.5,3-7.1c3-1.8,6.9-1,8.7,1.8c0.7,1.1,1,2.3,1.2,3.7l-20,12.1 c-1.2-0.7-2.2-1.6-2.8-2.6c-1.8-2.8-0.8-6.6,2.1-8.4C509.5,106.1,511.6,106.5,514.6,108.3z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.0956,
    y1: 113.1263,
    x2: 538.1879,
    y2: 143.0469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58A1F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 568.2999877929688 128 L 518.2000122070312 133.1999969482422 L 504.1000061035156 127.30000305175781 L 569.5 120.0999984741211 Z",
    className: "st17",
    style: {
      fill: "url('#SVGID_12_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.0112,
    y1: 96.9826,
    x2: 589.7599,
    y2: 121.6877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M554.6,100.3c2.6-3,4.7-4.3,8-3.4c3.6,1,5.5,4.9,4.4,8.7c-2,6.9-12.2,10.8-19,17.2 c-2.4-9.1-8.8-17.4-6.8-24.3c1.1-3.8,4.9-6.1,8.5-5.1C552.9,94.2,554,96.4,554.6,100.3z",
    style: {
      fill: "url('#SVGID_13_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.2542,
    y1: 104.3968,
    x2: 570.2236,
    y2: 113.365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M554.4,100.9c2.5-2.8,4.5-3.9,7.5-3.1c3.4,0.9,5.3,4.6,4.3,8.1c-1.9,6.4-11.5,9.9-17.9,15.7 c-2.3-8.4-8.5-16.2-6.6-22.5c1-3.5,4.6-5.6,8-4.7C552.7,95.3,553.8,97.3,554.4,100.9z",
    style: {
      fill: "url('#SVGID_14_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M554.4,100.9c2.5-2.8,4.5-3.9,7.5-3.1c3.4,0.9,5.3,4.6,4.3,8.1c0,0.1,0,0.1-0.1,0.2 c0.8-3.1-1.2-6.4-4.5-7.3c-3.1-0.9-5,0.2-7.4,2.6c-0.7-3.3-1.8-5.2-4.9-6c-3.3-0.9-6.8,0.8-7.8,3.9c0-0.1,0-0.1,0.1-0.2 c1-3.5,4.6-5.6,8-4.7C552.7,95.3,553.8,97.3,554.4,100.9z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M554.2,101.5c2.4-2.5,4.3-3.5,7.4-2.6c3.4,0.9,5.4,4.3,4.4,7.5c-0.4,1.2-1.1,2.3-2,3.3l-22.6-6.3 c-0.2-1.3-0.2-2.6,0.1-3.8c0.9-3.2,4.4-5,7.8-4.1C552.4,96.3,553.5,98.2,554.2,101.5z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.9795,
    y1: 113.4304,
    x2: 561.6019,
    y2: 140.156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M527.8,117.8c2.7-2.9,4.9-4.1,8.1-3.1c3.5,1.1,5.4,5.1,4.1,8.8c-2.3,6.8-12.6,10.4-19.6,16.5 c-2-9.2-8.2-17.7-6-24.5c1.3-3.8,5.1-6,8.6-4.8C526.4,111.6,527.4,113.9,527.8,117.8z",
    style: {
      fill: "url('#SVGID_15_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.3703,
    y1: 121.202,
    x2: 542.9961,
    y2: 131.4176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M527.6,118.5c2.6-2.7,4.6-3.8,7.6-2.8c3.3,1,5.1,4.7,4,8.2c-2.1,6.3-11.8,9.5-18.4,15.1 c-2-8.5-8-16.4-5.9-22.7c1.2-3.5,4.8-5.5,8.2-4.4C526.2,112.8,527.2,114.8,527.6,118.5z",
    style: {
      fill: "url('#SVGID_16_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M527.6,118.5c2.6-2.7,4.6-3.8,7.6-2.8c3.3,1,5.1,4.7,4,8.2c0,0.1,0,0.1-0.1,0.2c0.9-3.1-0.9-6.4-4.2-7.4 c-3-0.9-5,0-7.5,2.4c-0.6-3.3-1.6-5.2-4.6-6.2c-3.3-1-6.8,0.6-7.9,3.6c0-0.1,0-0.1,0.1-0.2c1.2-3.5,4.8-5.5,8.2-4.4 C526.2,112.8,527.2,114.8,527.6,118.5z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M527.5,119c2.5-2.4,4.4-3.3,7.5-2.4c3.3,1,5.2,4.5,4.2,7.6c-0.4,1.2-1.1,2.3-2.1,3.2l-22.4-7 c-0.2-1.3-0.2-2.6,0.2-3.8c1-3.2,4.6-4.9,8-3.8C525.8,113.7,526.9,115.6,527.5,119z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.3467,
    y1: 102.9483,
    x2: 580.1859,
    y2: 135.1311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M539.5,108.2c3.3-3.5,5.9-5,9.7-3.8c4.2,1.3,6.5,6.1,5,10.7c-2.7,8.2-15.1,12.5-23.6,19.9 c-2.4-11.1-9.9-21.3-7.2-29.6c1.5-4.6,6.2-7.2,10.4-5.8C537.7,100.8,539,103.5,539.5,108.2z",
    style: {
      fill: "url('#SVGID_17_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 514.8769,
    y1: 112.3055,
    x2: 557.7766,
    y2: 124.6068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M539.3,109c3.1-3.2,5.5-4.6,9.2-3.4c4,1.3,6.2,5.7,4.8,9.9c-2.5,7.6-14.2,11.4-22.1,18.2 c-2.4-10.2-9.6-19.8-7.1-27.4c1.4-4.2,5.8-6.6,9.8-5.3C537.5,102.2,538.7,104.6,539.3,109z",
    style: {
      fill: "url('#SVGID_18_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M539.3,109c3.1-3.2,5.5-4.6,9.2-3.4c4,1.3,6.2,5.7,4.8,9.9c0,0.1-0.1,0.2-0.1,0.2c1.1-3.7-1.1-7.7-5.1-9 c-3.7-1.1-6,0-9,2.9c-0.7-4-1.9-6.3-5.6-7.4c-4-1.2-8.2,0.7-9.5,4.4c0-0.1,0.1-0.2,0.1-0.2c1.4-4.2,5.8-6.6,9.8-5.3 C537.5,102.2,538.7,104.6,539.3,109z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M539.1,109.6c3-2.9,5.4-4,9-2.9c4,1.3,6.3,5.4,5,9.2c-0.5,1.4-1.4,2.7-2.5,3.9l-27-8.5 c-0.2-1.6-0.2-3.2,0.3-4.6c1.3-3.8,5.5-5.9,9.6-4.6C537.1,103.3,538.4,105.6,539.1,109.6z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.9825,
    y1: 111.893,
    x2: 577.8239,
    y2: 144.0767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M537.2,117.1c3.3-3.5,5.9-5,9.7-3.8c4.2,1.3,6.5,6.1,5,10.7c-2.7,8.2-15.1,12.5-23.6,19.9 c-2.4-11.1-9.9-21.3-7.2-29.6c1.5-4.6,6.2-7.2,10.4-5.8C535.4,109.7,536.6,112.4,537.2,117.1z",
    style: {
      fill: "url('#SVGID_19_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 512.5137,
    y1: 121.2508,
    x2: 555.413,
    y2: 133.552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M536.9,117.9c3.1-3.2,5.5-4.6,9.2-3.4c4,1.3,6.2,5.7,4.8,9.9c-2.5,7.6-14.2,11.4-22.1,18.2 c-2.4-10.2-9.6-19.8-7.1-27.4c1.4-4.2,5.8-6.6,9.8-5.3C535.1,111.1,536.3,113.6,536.9,117.9z",
    style: {
      fill: "url('#SVGID_20_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M536.9,117.9c3.1-3.2,5.5-4.6,9.2-3.4c4,1.3,6.2,5.7,4.8,9.9c0,0.1-0.1,0.2-0.1,0.2c1.1-3.7-1.1-7.7-5.1-9 c-3.7-1.1-6,0-9,2.9c-0.7-4-1.9-6.3-5.6-7.4c-4-1.2-8.2,0.7-9.5,4.4c0-0.1,0-0.2,0.1-0.2c1.4-4.2,5.8-6.6,9.8-5.3 C535.1,111.1,536.3,113.6,536.9,117.9z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M536.7,118.6c3-2.9,5.4-4,9-2.9c4,1.3,6.3,5.4,5,9.2c-0.5,1.4-1.4,2.7-2.5,3.9l-27-8.5 c-0.2-1.6-0.2-3.2,0.3-4.6c1.3-3.8,5.5-5.9,9.6-4.6C534.8,112.3,536,114.6,536.7,118.6z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.1148,
    y1: 109.2493,
    x2: 588.9094,
    y2: 133.7377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M558,113.2c2.5-2.7,4.5-3.8,7.4-2.9c3.2,1,4.9,4.6,3.8,8.1c-2.1,6.3-11.5,9.5-17.9,15.2 c-1.9-8.4-7.5-16.2-5.5-22.5c1.1-3.5,4.7-5.5,7.9-4.4C556.6,107.6,557.6,109.6,558,113.2z",
    style: {
      fill: "url('#SVGID_21_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.2172,
    y1: 116.3702,
    x2: 571.8585,
    y2: 125.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M557.8,113.9c2.3-2.5,4.2-3.5,7-2.6c3.1,1,4.7,4.3,3.6,7.5c-1.9,5.8-10.8,8.7-16.8,13.9 c-1.8-7.8-7.3-15-5.4-20.8c1.1-3.2,4.4-5,7.5-4C556.4,108.6,557.3,110.5,557.8,113.9z",
    style: {
      fill: "url('#SVGID_22_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M557.8,113.9c2.3-2.5,4.2-3.5,7-2.6c3.1,1,4.7,4.3,3.6,7.5c0,0.1,0,0.1-0.1,0.2c0.8-2.8-0.9-5.9-3.9-6.8 c-2.8-0.9-4.6,0-6.9,2.2c-0.5-3.1-1.5-4.8-4.3-5.7c-3-0.9-6.2,0.5-7.2,3.3c0-0.1,0-0.1,0.1-0.2c1.1-3.2,4.4-5,7.5-4 C556.4,108.6,557.3,110.5,557.8,113.9z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M557.6,114.3c2.3-2.2,4.1-3.1,6.9-2.2c3.1,1,4.8,4.1,3.8,7c-0.4,1.1-1,2.1-1.9,3l-20.5-6.4 c-0.2-1.2-0.1-2.4,0.2-3.5c1-2.9,4.2-4.5,7.3-3.5C556.1,109.5,557.1,111.3,557.6,114.3z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 568.2999877929688 128 L 569.5 120.0999984741211 L 582.5 126.5999984741211 Z",
    className: "st13",
    style: {
      fill: "rgb(245, 138, 31)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.3933,
    y1: 118.2479,
    x2: 590.1863,
    y2: 142.7357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M559.3,122.2c2.5-2.7,4.5-3.8,7.4-2.9c3.2,1,4.9,4.6,3.8,8.1c-2.1,6.3-11.5,9.5-17.9,15.2 c-1.9-8.4-7.5-16.2-5.5-22.5c1.1-3.5,4.7-5.5,7.9-4.4C557.9,116.6,558.8,118.6,559.3,122.2z",
    style: {
      fill: "url('#SVGID_23_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.4966,
    y1: 125.3683,
    x2: 573.1389,
    y2: 134.7283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF6691"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M559.1,122.9c2.3-2.5,4.2-3.5,7-2.6c3.1,1,4.7,4.3,3.6,7.5c-1.9,5.8-10.8,8.7-16.8,13.9 c-1.8-7.8-7.3-15-5.4-20.8c1.1-3.2,4.4-5,7.5-4C557.7,117.6,558.6,119.5,559.1,122.9z",
    style: {
      fill: "url('#SVGID_24_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M559.1,122.9c2.3-2.5,4.2-3.5,7-2.6c3.1,1,4.7,4.3,3.6,7.5c0,0.1,0,0.1-0.1,0.2c0.8-2.8-0.9-5.9-3.9-6.8 c-2.8-0.9-4.6,0-6.9,2.2c-0.5-3.1-1.5-4.8-4.3-5.7c-3-0.9-6.2,0.5-7.2,3.3c0-0.1,0-0.1,0.1-0.2c1.1-3.2,4.4-5,7.5-4 C557.7,117.6,558.6,119.5,559.1,122.9z",
    style: {
      opacity: 0.4,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M558.9,123.3c2.3-2.2,4.1-3.1,6.9-2.2c3.1,1,4.8,4.1,3.8,7c-0.4,1.1-1,2.1-1.9,3l-20.5-6.4 c-0.2-1.2-0.1-2.4,0.2-3.5c1-2.9,4.2-4.5,7.3-3.5C557.4,118.5,558.4,120.3,558.9,123.3z",
    style: {
      opacity: 0.2,
      fill: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 553.8701,
    y1: 130.4951,
    x2: 553.8701,
    y2: 194.7614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58A1F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 582.5 126.5999984741211 L 551.4000244140625 129.8000030517578 L 518.2000122070312 133.1999969482422 L 518.2000122070312 198.6999969482422 L 551.4000244140625 191.6999969482422 L 589.5999755859375 183.6999969482422 Z",
    className: "st30",
    style: {
      fill: "url('#SVGID_25_')",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M541.5,139.7c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.8-0.4,1v0c-0.3,0.3-0.6,0.4-1.1,0.4 c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.8,0.4-1l0,0l0,0C540.7,139.8,541.1,139.7,541.5,139.7L541.5,139.7z M542.2,140.5L542.2,140.5c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3l0,0c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.6C542.4,140.9,542.3,140.7,542.2,140.5z",
    style: {
      fill: "rgb(146, 148, 151)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M567.2,138.8c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.8-0.4,1l0,0 c-0.3,0.3-0.6,0.4-1.1,0.4c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.8,0.4-1v0l0,0 C566.5,138.9,566.8,138.8,567.2,138.8L567.2,138.8z M567.9,139.6L567.9,139.6c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3 l0,0c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.6 C568.2,140,568.1,139.8,567.9,139.6z",
    style: {
      fill: "rgb(146, 148, 151)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M563.7,169.5c0.4-0.7,0.8-1.5,1.1-2.5c0.4-1.3,0.8-2.9,1.1-4.7c0.4-2.4,0.6-5.2,0.7-8.5 c0.1-4,0.1-8.9,0-14.3c0.2-0.1,0.4-0.2,0.6-0.2c0.3,0,0.5,0.1,0.7,0.3l0,0c0.2,6.6,0.5,13.1,0.2,17.9c-0.3,4.9-0.8,8.9-1.8,12 c-0.2,0.6-0.4,1.1-0.6,1.6c-0.4,0.8-0.9,1.5-1.5,2.1c-0.7,0.7-1.5,1.3-2.3,1.7c-1,0.5-2.1,0.8-3.3,0.9c-0.1,0-0.1,0-0.2,0l0,0l0,0 l0,0c-1.4,0.1-2.7-0.1-4-0.7c-1.3-0.6-2.4-1.5-3.5-2.7c-2.1-2.4-3.8-5.9-5.3-10.4c-1-3-1.9-6.5-2.8-10.4c-0.7-3-1.3-6.4-1.9-9.9 l-0.2-1.3c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c0.8,5.1,1.9,10.3,2.8,14.2c1.3,5.6,2.7,10,4.3,13.2 c1.1,2.1,2.2,3.7,3.4,4.8c0.7,0.6,1.4,1,2.1,1.3c0.8,0.3,1.7,0.5,2.7,0.4l0,0c0.1,0,0.1,0,0.2,0c1.7-0.2,3-0.7,4-1.7 C562.5,172,563.2,170.9,563.7,169.5z",
    style: {
      fill: "rgb(209, 170, 103)",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 192.872802734375 13.09000015258789 L 192.872802734375 25 L 184.0327911376953 25 L 184.0327911376953 -7.720001220703125 L 194.75279235839844 -7.720001220703125 C 203.64613342285156 -7.720001220703125 208.09280395507812 -4.496665954589844 208.09280395507812 1.9500007629394531 C 208.09280395507812 5.736665725708008 206.2427978515625 8.666666030883789 202.5428009033203 10.739999771118164 L 212.0727996826172 25 L 202.0428009033203 25 L 195.10279846191406 13.09000015258789 L 192.872802734375 13.09000015258789 M 192.872802734375 6.450000762939453 L 194.52279663085938 6.450000762939453 C 197.6161346435547 6.450000762939453 199.1627960205078 5.083333969116211 199.1627960205078 2.3500003814697266 C 199.1627960205078 0.09666633605957031 197.64613342285156 -1.0300006866455078 194.61279296875 -1.0300006866455078 L 192.872802734375 -1.0300006866455078 L 192.872802734375 6.450000762939453 ZM 238.76913452148438 12.270000457763672 C 238.76913452148438 16.416667938232422 237.6524658203125 19.649999618530273 235.41912841796875 21.969999313354492 C 233.1924591064453 24.290000915527344 230.0724639892578 25.450000762939453 226.0591278076172 25.450000762939453 C 222.20579528808594 25.450000762939453 219.1424560546875 24.26333236694336 216.86912536621094 21.889999389648438 C 214.58912658691406 19.516666412353516 213.44912719726562 16.310001373291016 213.44912719726562 12.270000457763672 C 213.44912719726562 8.136667251586914 214.5657958984375 4.923334121704102 216.79913330078125 2.6299991607666016 C 219.03245544433594 0.3366661071777344 222.16246032714844 -0.8099994659423828 226.1891326904297 -0.8099994659423828 C 228.68246459960938 -0.8099994659423828 230.88246154785156 -0.2800006866455078 232.78912353515625 0.7800006866455078 C 234.7024688720703 1.8400001525878906 236.17579650878906 3.3600006103515625 237.20913696289062 5.340000152587891 C 238.24913024902344 7.313333511352539 238.76913452148438 9.623332977294922 238.76913452148438 12.270000457763672 M 222.33912658691406 12.270000457763672 C 222.33912658691406 14.443333625793457 222.62913513183594 16.10333251953125 223.20913696289062 17.25 C 223.79579162597656 18.389999389648438 224.7724609375 18.959999084472656 226.13912963867188 18.959999084472656 C 227.49913024902344 18.959999084472656 228.45913696289062 18.389999389648438 229.01913452148438 17.25 C 229.57913208007812 16.10333251953125 229.859130859375 14.443333625793457 229.859130859375 12.270000457763672 C 229.859130859375 10.103333473205566 229.57579040527344 8.466667175292969 229.00912475585938 7.3600006103515625 C 228.4424591064453 6.260000228881836 227.4724578857422 5.709999084472656 226.09912109375 5.709999084472656 C 224.75912475585938 5.709999084472656 223.79579162597656 6.25666618347168 223.20913696289062 7.350000381469727 C 222.62913513183594 8.450000762939453 222.33912658691406 10.09000015258789 222.33912658691406 12.270000457763672 ZM 263.3677062988281 17.209999084472656 C 263.3677062988281 19.92333221435547 262.44439697265625 21.976667404174805 260.59771728515625 23.3700008392334 C 258.744384765625 24.75666618347168 256.08770751953125 25.450000762939453 252.62771606445312 25.450000762939453 C 250.74771118164062 25.450000762939453 249.1143798828125 25.350000381469727 247.72772216796875 25.149999618530273 C 246.34104919433594 24.94333267211914 244.92437744140625 24.573333740234375 243.47772216796875 24.040000915527344 L 243.47772216796875 17.030000686645508 C 244.8310546875 17.630001068115234 246.31771850585938 18.123332977294922 247.93771362304688 18.510000228881836 C 249.55770874023438 18.89666748046875 251.0010528564453 19.09000015258789 252.26771545410156 19.09000015258789 C 254.16770935058594 19.09000015258789 255.1177215576172 18.656665802001953 255.1177215576172 17.790000915527344 C 255.1177215576172 17.343334197998047 254.85104370117188 16.946666717529297 254.31771850585938 16.600000381469727 C 253.79104614257812 16.246665954589844 252.2510528564453 15.563333511352539 249.69772338867188 14.550000190734863 C 247.3710479736328 13.59666633605957 245.744384765625 12.510000228881836 244.81771850585938 11.289999961853027 C 243.89105224609375 10.076666831970215 243.42771911621094 8.536666870117188 243.42771911621094 6.670000076293945 C 243.42771911621094 4.309999465942383 244.3377227783203 2.4733333587646484 246.15771484375 1.1599998474121094 C 247.97772216796875 -0.1533336639404297 250.55438232421875 -0.8099994659423828 253.88771057128906 -0.8099994659423828 C 255.55438232421875 -0.8099994659423828 257.1243896484375 -0.6266670227050781 258.59771728515625 -0.26000022888183594 C 260.06439208984375 0.10666656494140625 261.58770751953125 0.6399993896484375 263.167724609375 1.3400001525878906 L 260.7977294921875 6.979999542236328 C 259.6377258300781 6.459999084472656 258.40771484375 6.016666412353516 257.10772705078125 5.649999618530273 C 255.80770874023438 5.283332824707031 254.74771118164062 5.100000381469727 253.92771911621094 5.100000381469727 C 252.494384765625 5.100000381469727 251.7777099609375 5.453332901000977 251.7777099609375 6.159999847412109 C 251.7777099609375 6.586666107177734 252.0277099609375 6.953332901000977 252.5277099609375 7.260000228881836 C 253.0277099609375 7.566667556762695 254.47105407714844 8.190000534057617 256.85772705078125 9.130000114440918 C 258.6377258300781 9.863333702087402 259.9610595703125 10.579999923706055 260.8277282714844 11.279999732971191 C 261.7010498046875 11.979999542236328 262.3443908691406 12.803333282470703 262.7577209472656 13.75 C 263.16436767578125 14.696666717529297 263.3677062988281 15.850000381469727 263.3677062988281 17.209999084472656 ZM 284.80584716796875 25 L 283.1258544921875 21.639999389648438 L 282.94586181640625 21.639999389648438 C 281.77252197265625 23.106666564941406 280.572509765625 24.106666564941406 279.3458557128906 24.639999389648438 C 278.1191711425781 25.18000030517578 276.5391845703125 25.450000762939453 274.6058349609375 25.450000762939453 C 272.2125244140625 25.450000762939453 270.33251953125 24.733333587646484 268.9658508300781 23.299999237060547 C 267.592529296875 21.866666793823242 266.9058532714844 19.85333251953125 266.9058532714844 17.260000228881836 C 266.9058532714844 14.5600004196167 267.8458557128906 12.546667098999023 269.7258605957031 11.220000267028809 C 271.6058349609375 9.899999618530273 274.3291931152344 9.15999984741211 277.8958435058594 9 L 282.1258544921875 8.860000610351562 L 282.1258544921875 8.510000228881836 C 282.1258544921875 6.416666030883789 281.0958557128906 5.370000839233398 279.0358581542969 5.370000839233398 C 277.1825256347656 5.370000839233398 274.83251953125 5.996665954589844 271.98583984375 7.25 L 269.4558410644531 1.4799995422363281 C 272.4091796875 -0.04666709899902344 276.1391906738281 -0.8099994659423828 280.6458435058594 -0.8099994659423828 C 283.899169921875 -0.8099994659423828 286.4158630371094 -0.00333404541015625 288.19586181640625 1.6100006103515625 C 289.9825134277344 3.2233333587646484 290.8758544921875 5.476667404174805 290.8758544921875 8.370000839233398 L 290.8758544921875 25 L 284.80584716796875 25 M 278.31585693359375 19.270000457763672 C 279.3758544921875 19.270000457763672 280.28253173828125 18.933334350585938 281.0358581542969 18.260000228881836 C 281.7891845703125 17.593334197998047 282.1658630371094 16.720001220703125 282.1658630371094 15.640000343322754 L 282.1658630371094 13.680000305175781 L 280.1558532714844 13.760000228881836 C 277.2758483886719 13.866666793823242 275.8358459472656 14.926666259765625 275.8358459472656 16.939998626708984 C 275.8358459472656 18.49333381652832 276.6625061035156 19.270000457763672 278.31585693359375 19.270000457763672 ZM 312.167236328125 -0.8099994659423828 C 312.92724609375 -0.8099994659423828 313.65057373046875 -0.75 314.3372497558594 -0.6299991607666016 L 314.8272399902344 -0.5400009155273438 L 314.0472412109375 7.719999313354492 C 313.33392333984375 7.540000915527344 312.340576171875 7.450000762939453 311.0672607421875 7.450000762939453 C 309.16058349609375 7.450000762939453 307.77392578125 7.886667251586914 306.9072570800781 8.760000228881836 C 306.04058837890625 9.633333206176758 305.60723876953125 10.890000343322754 305.60723876953125 12.529999732971191 L 305.60723876953125 25 L 296.85723876953125 25 L 296.85723876953125 -0.3600006103515625 L 303.36724853515625 -0.3600006103515625 L 304.73724365234375 3.690000534057617 L 305.1572570800781 3.690000534057617 C 305.8905944824219 2.3500003814697266 306.91058349609375 1.2666664123535156 308.2172546386719 0.4400005340576172 C 309.52392578125 -0.39333343505859375 310.840576171875 -0.8099994659423828 312.167236328125 -0.8099994659423828 ZM 327.20147705078125 25 L 318.45147705078125 25 L 318.45147705078125 -0.3600006103515625 L 327.20147705078125 -0.3600006103515625 L 327.20147705078125 25 M 318.2214660644531 -6.670000076293945 C 318.2214660644531 -7.983333587646484 318.588134765625 -8.959999084472656 319.32147216796875 -9.599998474121094 C 320.0548095703125 -10.240001678466797 321.23480224609375 -10.560001373291016 322.8614807128906 -10.560001373291016 C 324.4814758300781 -10.560001373291016 325.664794921875 -10.233333587646484 326.4114685058594 -9.580001831054688 C 327.15814208984375 -8.919998168945312 327.5314636230469 -7.950000762939453 327.5314636230469 -6.670000076293945 C 327.5314636230469 -4.10333251953125 325.97479248046875 -2.8199996948242188 322.8614807128906 -2.8199996948242188 C 319.76812744140625 -2.8199996948242188 318.2214660644531 -4.10333251953125 318.2214660644531 -6.670000076293945 ZM 357.5499572753906 12.270000457763672 C 357.5499572753906 16.416667938232422 356.43328857421875 19.649999618530273 354.199951171875 21.969999313354492 C 351.9732971191406 24.290000915527344 348.8533020019531 25.450000762939453 344.8399658203125 25.450000762939453 C 340.98663330078125 25.450000762939453 337.9233093261719 24.26333236694336 335.64996337890625 21.889999389648438 C 333.3699645996094 19.516666412353516 332.22998046875 16.310001373291016 332.22998046875 12.270000457763672 C 332.22998046875 8.136667251586914 333.34661865234375 4.923334121704102 335.5799560546875 2.6299991607666016 C 337.81329345703125 0.3366661071777344 340.94329833984375 -0.8099994659423828 344.969970703125 -0.8099994659423828 C 347.4632873535156 -0.8099994659423828 349.6632995605469 -0.2800006866455078 351.5699768066406 0.7800006866455078 C 353.4833068847656 1.8400001525878906 354.9566345214844 3.3600006103515625 355.9899597167969 5.340000152587891 C 357.02996826171875 7.313333511352539 357.5499572753906 9.623332977294922 357.5499572753906 12.270000457763672 M 341.1199645996094 12.270000457763672 C 341.1199645996094 14.443333625793457 341.40997314453125 16.10333251953125 341.9899597167969 17.25 C 342.5766296386719 18.389999389648438 343.5533142089844 18.959999084472656 344.9199523925781 18.959999084472656 C 346.27996826171875 18.959999084472656 347.2399597167969 18.389999389648438 347.7999572753906 17.25 C 348.3599548339844 16.10333251953125 348.63995361328125 14.443333625793457 348.63995361328125 12.270000457763672 C 348.63995361328125 10.103333473205566 348.35662841796875 8.466667175292969 347.78997802734375 7.3600006103515625 C 347.2232971191406 6.260000228881836 346.2532958984375 5.709999084472656 344.8799743652344 5.709999084472656 C 343.53997802734375 5.709999084472656 342.5766296386719 6.25666618347168 341.9899597167969 7.350000381469727 C 341.40997314453125 8.450000762939453 341.1199645996094 10.09000015258789 341.1199645996094 12.270000457763672 Z",
    transform: "matrix(1.1344845294952393, 0, 0, 1.1344845294952393, -28.493328094482422, 49.893775939941406)",
    style: {
      fill: "rgb(245, 138, 31)",
      whiteSpace: "pre",
      color: "rgb(245, 138, 31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 305.896484375 173.72999572753906 C 305.896484375 176.02999877929688 305.309814453125 178.07333374023438 304.136474609375 179.86000061035156 C 302.9698181152344 181.64666748046875 301.2864685058594 183.03334045410156 299.08648681640625 184.02000427246094 C 296.886474609375 185.01333618164062 294.3064880371094 185.50999450683594 291.3464660644531 185.50999450683594 C 288.8731384277344 185.50999450683594 286.7998046875 185.336669921875 285.12646484375 184.99000549316406 C 283.44647216796875 184.64332580566406 281.7031555175781 184.0366668701172 279.896484375 183.1699981689453 L 279.896484375 174.22999572753906 C 281.8031311035156 175.21665954589844 283.789794921875 175.98333740234375 285.8564758300781 176.52999877929688 C 287.92315673828125 177.0833282470703 289.81982421875 177.36000061035156 291.5464782714844 177.36000061035156 C 293.03314208984375 177.36000061035156 294.1231384277344 177.10000610351562 294.81646728515625 176.5800018310547 C 295.5164794921875 176.06666564941406 295.8664855957031 175.40333557128906 295.8664855957031 174.58999633789062 C 295.8664855957031 174.0833282470703 295.7264709472656 173.63999938964844 295.44647216796875 173.25999450683594 C 295.1664733886719 172.8800048828125 294.71649169921875 172.4933319091797 294.0964660644531 172.10000610351562 C 293.4764709472656 171.7133331298828 291.8298034667969 170.9166717529297 289.1564636230469 169.7100067138672 C 286.7364807128906 168.61000061035156 284.92315673828125 167.54666137695312 283.7164611816406 166.52000427246094 C 282.5031433105469 165.48666381835938 281.6064758300781 164.3000030517578 281.0264892578125 162.95999145507812 C 280.4398193359375 161.6266632080078 280.146484375 160.0433349609375 280.146484375 158.20999145507812 C 280.146484375 154.79000854492188 281.3898010253906 152.1233367919922 283.87646484375 150.20999145507812 C 286.3631286621094 148.30332946777344 289.78314208984375 147.35000610351562 294.136474609375 147.35000610351562 C 297.9764709472656 147.35000610351562 301.896484375 148.23666381835938 305.896484375 150.00999450683594 L 302.81646728515625 157.75999450683594 C 299.3498229980469 156.1666717529297 296.3531494140625 155.3699951171875 293.82647705078125 155.3699951171875 C 292.5264892578125 155.3699951171875 291.5798034667969 155.59666442871094 290.9864807128906 156.0500030517578 C 290.39312744140625 156.50999450683594 290.0964660644531 157.0800018310547 290.0964660644531 157.75999450683594 C 290.0964660644531 158.48666381835938 290.47314453125 159.1366729736328 291.2264709472656 159.70999145507812 C 291.97979736328125 160.2833251953125 294.02313232421875 161.3333282470703 297.3564758300781 162.86000061035156 C 300.5564880371094 164.3000030517578 302.7798156738281 165.8433380126953 304.0264892578125 167.49000549316406 C 305.27313232421875 169.14334106445312 305.896484375 171.22332763671875 305.896484375 173.72999572753906 ZM 325.1318359375 177.66000366210938 C 326.47186279296875 177.66000366210938 328.07183837890625 177.3300018310547 329.9318542480469 176.6699981689453 L 329.9318542480469 183.91000366210938 C 328.59185791015625 184.48333740234375 327.3185119628906 184.89332580566406 326.1118469238281 185.13999938964844 C 324.89849853515625 185.3866729736328 323.478515625 185.50999450683594 321.8518371582031 185.50999450683594 C 318.5185241699219 185.50999450683594 316.11517333984375 184.69332885742188 314.641845703125 183.05999755859375 C 313.16851806640625 181.42666625976562 312.4318542480469 178.9166717529297 312.4318542480469 175.52999877929688 L 312.4318542480469 163.6699981689453 L 308.96185302734375 163.6699981689453 L 308.96185302734375 159.6300048828125 L 313.3718566894531 156.50999450683594 L 315.94183349609375 150.47000122070312 L 322.44183349609375 150.47000122070312 L 322.44183349609375 156.22999572753906 L 329.5018310546875 156.22999572753906 L 329.5018310546875 163.6699981689453 L 322.44183349609375 163.6699981689453 L 322.44183349609375 174.8699951171875 C 322.44183349609375 176.72999572753906 323.3385009765625 177.66000366210938 325.1318359375 177.66000366210938 ZM 362.4150085449219 170.5500030517578 C 362.4150085449219 175.2566680908203 361.1483459472656 178.92666625976562 358.6150207519531 181.55999755859375 C 356.0883483886719 184.19332885742188 352.54833984375 185.50999450683594 347.9950256347656 185.50999450683594 C 343.62835693359375 185.50999450683594 340.155029296875 184.163330078125 337.57501220703125 181.47000122070312 C 334.98834228515625 178.77667236328125 333.69500732421875 175.1366729736328 333.69500732421875 170.5500030517578 C 333.69500732421875 165.8633270263672 334.961669921875 162.22000122070312 337.4950256347656 159.6199951171875 C 340.0283508300781 157.02000427246094 343.5783386230469 155.72000122070312 348.14501953125 155.72000122070312 C 350.9716796875 155.72000122070312 353.4683532714844 156.32333374023438 355.635009765625 157.52999877929688 C 357.80169677734375 158.72999572753906 359.4750061035156 160.4499969482422 360.655029296875 162.69000244140625 C 361.8283386230469 164.93666076660156 362.4150085449219 167.55667114257812 362.4150085449219 170.5500030517578 M 343.7750244140625 170.5500030517578 C 343.7750244140625 173.02333068847656 344.1050109863281 174.9066619873047 344.7650146484375 176.1999969482422 C 345.4250183105469 177.4933319091797 346.5350036621094 178.13999938964844 348.0950012207031 178.13999938964844 C 349.635009765625 178.13999938964844 350.7216796875 177.4933319091797 351.3550109863281 176.1999969482422 C 351.98834228515625 174.9066619873047 352.3050231933594 173.02333068847656 352.3050231933594 170.5500030517578 C 352.3050231933594 168.09666442871094 351.9850158691406 166.2433319091797 351.3450012207031 164.99000549316406 C 350.70501708984375 163.73666381835938 349.6050109863281 163.11000061035156 348.0450134277344 163.11000061035156 C 346.5183410644531 163.11000061035156 345.4250183105469 163.73333740234375 344.7650146484375 164.97999572753906 C 344.1050109863281 166.22666931152344 343.7750244140625 168.0833282470703 343.7750244140625 170.5500030517578 ZM 385.443115234375 155.72000122070312 C 386.3097839355469 155.72000122070312 387.13311767578125 155.79000854492188 387.9131164550781 155.92999267578125 L 388.4731140136719 156.02999877929688 L 387.5830993652344 165.39999389648438 C 386.769775390625 165.19332885742188 385.6430969238281 165.08999633789062 384.2030944824219 165.08999633789062 C 382.03643798828125 165.08999633789062 380.4631042480469 165.586669921875 379.48309326171875 166.5800018310547 C 378.50311279296875 167.56666564941406 378.0130920410156 168.9933319091797 378.0130920410156 170.86000061035156 L 378.0130920410156 185 L 368.0830993652344 185 L 368.0830993652344 156.22999572753906 L 375.4731140136719 156.22999572753906 L 377.0231018066406 160.8300018310547 L 377.50311279296875 160.8300018310547 C 378.32977294921875 159.30332946777344 379.48309326171875 158.07000732421875 380.9631042480469 157.1300048828125 C 382.44976806640625 156.19000244140625 383.943115234375 155.72000122070312 385.443115234375 155.72000122070312 ZM 406.3657531738281 185.50999450683594 C 401.5724182128906 185.50999450683594 397.8524169921875 184.23666381835938 395.20574951171875 181.69000244140625 C 392.5523986816406 179.14334106445312 391.2257385253906 175.51666259765625 391.2257385253906 170.80999755859375 C 391.2257385253906 165.9499969482422 392.45574951171875 162.22000122070312 394.9157409667969 159.6199951171875 C 397.36907958984375 157.02000427246094 400.8724060058594 155.72000122070312 405.4257507324219 155.72000122070312 C 409.75909423828125 155.72000122070312 413.1057434082031 156.85000610351562 415.46575927734375 159.11000061035156 C 417.82574462890625 161.3699951171875 419.0057373046875 164.6266632080078 419.0057373046875 168.8800048828125 L 419.0057373046875 173.2899932861328 L 401.2557373046875 173.2899932861328 C 401.3224182128906 174.90333557128906 401.91241455078125 176.1666717529297 403.0257568359375 177.0800018310547 C 404.1324157714844 177.9933319091797 405.6424255371094 178.4499969482422 407.5557556152344 178.4499969482422 C 409.3023986816406 178.4499969482422 410.90576171875 178.28334045410156 412.3657531738281 177.9499969482422 C 413.8323974609375 177.6233367919922 415.4190673828125 177.06333923339844 417.125732421875 176.27000427246094 L 417.125732421875 183.39999389648438 C 415.5724182128906 184.19332885742188 413.96575927734375 184.7433319091797 412.3057556152344 185.0500030517578 C 410.645751953125 185.35667419433594 408.6657409667969 185.50999450683594 406.3657531738281 185.50999450683594 M 405.7757568359375 162.47999572753906 C 404.60906982421875 162.47999572753906 403.6324157714844 162.84666442871094 402.8457336425781 163.5800018310547 C 402.05908203125 164.32000732421875 401.5990905761719 165.47666931152344 401.46575927734375 167.0500030517578 L 409.9957580566406 167.0500030517578 C 409.96240234375 165.663330078125 409.569091796875 164.55332946777344 408.81573486328125 163.72000122070312 C 408.0624084472656 162.89334106445312 407.049072265625 162.47999572753906 405.7757568359375 162.47999572753906 Z",
    transform: "matrix(1, 0, 0, 1, -84.5828857421875, -51.68954086303711)",
    style: {
      fill: "rgb(245, 138, 31)",
      whiteSpace: "pre",
      color: "rgb(245, 138, 31)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4104deefbdd5d3ef1b2bb17f854dcbf6.svg";
export { ForwardRef as ReactComponent };